export const voiceOverFocus = el => {
    console.log(el);
    var focusInterval = 10; // ms, time between function calls
    var focusTotalRepetitions = 10; // number of repetitions

    el.setAttribute("tabindex", "0");
    el.blur();

    var focusRepetitions = 0;
    var interval = window.setInterval(function () {
        el.focus();
        focusRepetitions++;
        if (focusRepetitions >= focusTotalRepetitions) {
            window.clearInterval(interval);
        }
    }, focusInterval);
};
